/**
 * Configuration applicative (variables VITE_* au build)
 */
export const isRegistrationAllowed = () =>
  import.meta.env.VITE_ALLOW_REGISTRATION === 'true';

export default {
  isRegistrationAllowed
};
